/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import VideoIcon from "../../atoms/icons/video-icon";

import { Link } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import wretch from "wretch";
import "./sidebar-content.m.css";
import CarouselSidebar from "../../atoms/carousel-sidebar";

const SideBarContent = ({ title, speed, state }) => {
  const [items, setItems] = useState([]);

  const getItems = async () => {
    // const url = state
    //   ? "/api/v1/collections/photo-gallery-pv?limit=10&sort=latest-published"
    //   : "/api/v1/collections/entertainment-news?limit=10&sort=latest-published";

    const url =
      state === "photo"
        ? "/api/v1/collections/photo-gallery-pv?limit=10&sort=latest-published"
        : state === "cinema"
        ? "/api/v1/collections/entertainment-news?limit=10&sort=latest-published"
        : "/api/v1/collections/story-page-video";

    try {
      const data = await wretch()
        .url(url)
        .get()
        .json((response) => {
          return response;
        });

      setItems(data.items.map((el) => el.story));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getItems();
  }, []);

  const getItemCard = (story, index) => {
    return (
      <Link href={story.url} key={index}>
        <div styleName="content-card">
          <CardImage story={story} aspectRatio={[16, 9]} imageType="image16x9" renderedWidth={720} widths={[700]} />

          {story["story-template"] === "video" && (
            <div styleName="video-icon">
              <VideoIcon width="40" height="40" />
            </div>
          )}
        </div>
      </Link>
    );
  };

  return (
    <div styleName={state ? "wrapper wrapper-photo" : "wrapper"}>
      <div styleName="title">{title}</div>
      <div styleName="content-element">
        <CarouselSidebar
          options={{
            autoplay: true,
            speed: 500,
            dots: true
          }}
        >
          {items.length > 0 && items.slice(0, 5).map((item, index) => getItemCard(item, index))}
        </CarouselSidebar>
      </div>
    </div>
  );
};

export default SideBarContent;
